import { IFinalEvent } from "types/event"
import { OptimizedEvent } from "types/optimizedEvent"

export const sortPrice = (list: IFinalEvent | OptimizedEvent) => {
    if (list?.availableTickets) {
        const x = list?.availableTickets?.sort((a, b) =>
            a?.discount?.previous_value
                ? a?.discount?.current_value - b?.discount?.current_value
                : a?.price - b?.price
        )

        return x[0]
    }
}
